import { memo } from 'react'
import { useNavigate } from 'react-router-dom'
import Skeleton from '../../../../skeleton/Skeleton'

function CarCode({ code, title, isUser }) {
  const navigate = useNavigate()
  let userPage = window.location.href.split('/user')?.[1]

  return (
    <div className={'flex items-center gap-2 mt-8 mb-16'}>
      {!userPage && (
        <div
          onClick={() => navigate(isUser ? '/user/car' : '/cars')}
          className="cursor-pointer w-18 h-18 bg-light-blue dark:bg-slate-600 rounded-xl flex items-center justify-center"
        >
          <i className={'icon-arrow-right text-2xl text-main dark:text-slate-200'} />
        </div>
      )}
      <div className="px-6 h-18 w-full rounded-xl flex items-center bg-orange-100 dark:bg-sky-400 dark:bg-opacity-20">
        <p className={'text-base sm:text-xl text-secondary dark:text-slate-200'}>
          {title}{' '}
          <b className={'text-secondary pr-2 dark:text-slate-200'}>{code ? code : <Skeleton />}</b>
        </p>
      </div>
    </div>
  )
}

export default memo(CarCode)
